
import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import * as yup from 'yup';

import User from 'store/models/User';
import AppState, { selectTwitchConfig, selectAuthConfig } from 'store/AppState';

import Modal, { ModalHeader, ModalTitle, ModalContent, ModalActions } from 'components/Modal';
import TextInput from 'components/forms/TextInput';
import { Form } from 'components/forms/Form';
import { ServerErrors } from 'components/forms/Error';
import Button, { ButtonListUniform, ButtonListCenter, TwitchLoginButton } from 'components/Button';

const FIELDS = ['email', 'username', 'password'];

const schema = yup.object().shape({
  username: yup.string().min(5).required(),
  email: yup.string().required(),
  password: yup.string().min(5).required(),
});


// ======================
// STORE
// ====================== 
const actions = {
  createUser: User.actions.createUser,
  authUser: User.actions.authUser,
  signup: User.actions.signup,
  twitchAuth: User.actions.twitchAuth,
}

const selector = state => {
  return {
    twitchConfig: selectTwitchConfig(state),
    authConfig: selectAuthConfig(state),
  };
}

const withConnect = connect(selector, actions);



// ======================
// COMPONENT
// ====================== 
class SignupModal extends React.Component {
  state = {
    values: _.reduce(FIELDS, (acc, e) => _.set(acc, e, ''), {}),
    errors: _.reduce(FIELDS, (acc, e) => _.set(acc, e, null), {}),
    edits: _.reduce(FIELDS, (acc, e) => _.set(acc, e, false), {}),
    saving: false,
    savingTwitch: false,
  }

  onChange = (value, name) => {
    this.setState({ 
      values: {...this.state.values, [name]: value},
      edits: {...this.state.edits, [name]: true}
    });
  }

  onSubmit = async () => {
    let { onClose, signup } = this.props;
    let { values, edits, errors } = this.state;
    schema.validate(values, {abortEarly: false})
      .then(v => {
        this.setState({ saving: true });
        signup(v)
          .then(() => {
            this.setState({ saving: false });
            onClose();
          })
          .catch(err => this.setState({ 
            saving: false,
            errors: { server: err.message }
          }));
      })
      .catch(e => {
        let err = _.reduce(e.inner, (acc, v) => _.set(acc, v.path, v.errors), {})
        this.setState({
          errors: _.reduce(e.inner, (acc, v) => _.set(acc, v.path, v.errors), {})
        })
      });
  }
  
  onTwitchAuth = e => {
    e.preventDefault();
    let { twitchAuth, onClose } = this.props;
    twitchAuth().then(() => onClose());
  }

  onSuccess = (e) => {
    if(_.get(this.props, 'data.to')) {
      this.navigateTo(_.get(this.props, 'data.to'));
    } else {
      this.props.onClose?.();
    }
  }

  render() {
    let { data } = this.props;
    let { values, errors, saving, savingTwitch } = this.state;
    return (
      <Modal className="signup">
        <ModalHeader>
          <ModalTitle>Join HappyStreams!</ModalTitle>
        </ModalHeader>
        <ModalContent>
          
          <ServerErrors errors={errors} />
          <Form onSubmit={this.onSubmit}>
            <TextInput
              label="Username"
              name="username"
              value={values.username}
              errors={errors.username}
              focused={true}
              onChange={this.onChange}
              onSubmit={this.onSubmit} />
            <TextInput
              label="Email"
              name="email"
              value={values.email}
              errors={errors.email}
              onChange={this.onChange}
              onSubmit={this.onSubmit} />
            <TextInput
              label="Password"
              name="password"
              type="password"
              value={values.password}
              errors={errors.password}
              onChange={this.onChange}
              onSubmit={this.onSubmit} />
          </Form>
          <ButtonListCenter className="email-action">
            <Button size="l"
              onClick={this.onSubmit}
              loading={saving}>Signup With Email</Button>
          </ButtonListCenter>
          <div className="social-label">Or using Twitch</div>
          <ButtonListCenter className="social">
            <TwitchLoginButton loading={savingTwitch} onClick={this.onTwitchAuth} />
          </ButtonListCenter>
        </ModalContent>
       
      </Modal>);
  }
};

export default SignupModal 
  |> withConnect
